"use client";

export type PaywallTrigger = "daily_limit_reached" | "duration_limit_hit" | "premium_feature_clicked";
export type NormalizedPaywallTrigger = "daily_limit" | "feature_gate" | "manual";

export type StoredPaywallContext = {
  paywall_impression_id: string;
  trigger_type: PaywallTrigger;
  trigger: NormalizedPaywallTrigger;
  feature?: string | null;
  links_used_today?: number | null;
  links_remaining?: number | null;
  plan_viewed_at?: string | null;
  upgrade_clicked_at?: string | null;
  upgrade_entry_point?: string | null;
};

export const LAST_PAYWALL_KEY = "_last_paywall";

type SessionStorageLike = Pick<Storage, "getItem" | "setItem" | "removeItem">;

function getSessionStorage() {
  try {
    if (typeof window !== "undefined" && window.sessionStorage) {
      return window.sessionStorage;
    }
  } catch {
    return null;
  }

  try {
    return (globalThis as { sessionStorage?: SessionStorageLike }).sessionStorage ?? null;
  } catch {
    return null;
  }
}

export function readStoredPaywallContext() {
  const storage = getSessionStorage();
  const raw = storage?.getItem(LAST_PAYWALL_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as StoredPaywallContext;
  } catch {
    return null;
  }
}

export function writeStoredPaywallContext(context: StoredPaywallContext) {
  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  try {
    storage.setItem(LAST_PAYWALL_KEY, JSON.stringify(context));
  } catch {}
}

export function clearStoredPaywallContext() {
  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  try {
    storage.removeItem(LAST_PAYWALL_KEY);
  } catch {}
}
